// Constants.
import * as ShareDashboardConstants from 'constants/ShareDashboardConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  token: '',
};

export default function profile(state = initialState, action = {}) {
  switch (action.type) {
    case ShareDashboardConstants.LOAD_SHARE_DASHBOARD_TOKEN_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ShareDashboardConstants.LOAD_SHARE_DASHBOARD_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        token: action.token,
      };
    case ShareDashboardConstants.LOAD_SHARE_DASHBOARD_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        token: '',
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        token: '',
      };
    default:
      return state;
  }
}
